// ----------------------------------------------------------------------

export enum HttpStatusCodes {
  StatusSuccess = 200,
  StatusCreated = 201,
  StatusBadRequest = 400,
  StatusUnAuthorized = 401,
  StatusForbidden = 403,
  StatusNotFound = 404
}
